import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useDeleteConversation } from "@/hooks/queries";

export function DeleteConversationDialog({ conversation, open, onOpenChange, redirectTo }) {
  const del = useDeleteConversation();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const confirm = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await del.mutateAsync(conversation.id);
      toast.success("Conversation deleted");
      onOpenChange(false);
      if (redirectTo) navigate(redirectTo, { replace: true });
    } catch (err) {
      toast.error(err.message || "Couldn't delete the conversation");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="border-white/10 bg-ink-850" data-testid="delete-conversation-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-white">Delete this conversation?</AlertDialogTitle>
          <AlertDialogDescription className="text-zinc-400">
            “{conversation?.title}” and all of its messages will be permanently deleted. This can't be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="border-white/10 bg-transparent text-zinc-300 hover:bg-white/[0.06] hover:text-white" data-testid="delete-conversation-cancel">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction onClick={confirm} disabled={busy} className="bg-rose-500 text-white hover:bg-rose-500/90" data-testid="delete-conversation-confirm">
            {busy ? "Deleting…" : "Delete"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
